"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlobFilename = void 0;
const getBlobFilename = (response) => {
    const contentDisposition = response.headers['content-disposition'];
    if (!contentDisposition)
        return 'downloaded-file';
    const filenameUtf8 = contentDisposition.match(/filename\*=utf-8''(.+)$/i);
    if (filenameUtf8) {
        return decodeURIComponent(filenameUtf8[1]);
    }
    const filenameMatch = contentDisposition.match(/filename="?(.*?)"?($|;)/i);
    if (filenameMatch) {
        return filenameMatch[1];
    }
    return 'downloaded-file';
};
exports.getBlobFilename = getBlobFilename;
